module.exports = __webpack_public_path__ + "img/carshina21_03.8bffa56b.jpg";